import VueWrapper from '@/components/core/Vue/vue.wrapper';
import {Component} from 'vue-property-decorator';

@Component({
    name: 'UnauthorizedComponent',
})
export default class UnauthorizedComponent extends VueWrapper {
    public goToHome() {
        this.$router.push({name: 'sites-list'});
    }

    public goBack() {
        this.$router.go(-1);
    }
}
